module.exports = __webpack_public_path__ + "static/img/setup_step05@2x.23f0374.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactUs/creatorProcess/setup_step05@2x.png
// module id = 8W5v
// module chunks = 0